import React from 'react'

import { DynamicProfileFormScreen } from '../DynamicProfileFormScreen'

export const UpdateDynamicProfileFormScreen = () => {
  return (
    <DynamicProfileFormScreen variant='update' />
  )
}